import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { FilterQuery } from '../../repository/types'
import type { User } from '../User'

@InputType()
export class SetUserRoleArgs extends ActionArgs {
  @Field(() => GraphQLJSON)
  filter: FilterQuery<User>

  @Field(() => [String])
  roles: string[]

  @Field(() => Boolean, { nullable: true })
  set?: boolean
}

export interface ISetUserRole extends IAction<User, SetUserRoleArgs> {}
